let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

export const clearLogoutHandler = () => {
  logoutHandler = null;
};

class ApiError extends Error {
  constructor(message, status, data = null) {
    super(message);

    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

async function parseResponse(response) {
  const contentType = response.headers.get("content-type");

  if (contentType?.includes("application/json")) {
    return await response.json();
  }

  return {
    message: await response.text(),
  };
}

export async function apiFetch(url, options = {}) {
  try {
    const response = await fetch(url, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
    });

    const result = await parseResponse(response);

    if (response.ok) {
      return result;
    }

    if (response.status === 401) {
      if (logoutHandler) {
        logoutHandler();
      }

      throw new ApiError(
        result?.message || "Session expired.",
        401,
        result
      );
    }

    throw new ApiError(
      result?.message || "Request failed.",
      response.status,
      result
    );

  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    if (
      error instanceof TypeError &&
      error.message === "Failed to fetch"
    ) {
      throw new ApiError(
        "Unable to communicate with the server.",
        0
      );
    }

    if (process.env.REACT_APP_ENV === "development") {
      console.error("API Request Error:", error);
    }

    throw new ApiError(
      error.message || "An unexpected error occurred.",
      500
    );
  }
}